import { Col, Flex, Tag } from 'antd';
import { RecentHealth } from '../../apis/mgmt/api';
import { DataViewProps } from '../common/DataView';
import { get } from 'http';


const gray = '#D9D9D9';
const semaphoreColors : any = {
    GREEN: '#50B692',
    YELLOW: '#F3C15C',
    ORANGE: '#BF8756',
    RED: '#b65057ff',
};

export const getSemaphoreColor = function (semaphore: string | undefined) {
    return semaphore && semaphoreColors[semaphore] || gray;
}

const tag = function(props: {title: string, color: string, size?: number}) {
    //return <Tag title={props.title} color={props.color}>{props.title[0]}</Tag>
    const { title, color } = props;
    const size = props.size || 15;
    return (
        <svg height={size} width={size} xmlns="http://www.w3.org/2000/svg">
            <circle r={size/2} cx={size/2} cy={size/2} fill={color} >
                <title>{title}</title>
            </circle>
        </svg>
    );
}

export const RecentHealthIndicator = function ( props:
    DataViewProps<RecentHealth>
) {
    const data = props.data;

    return (data && (
        <Flex justify='flex-end' align='flex-end' gap={5} style={{paddingBottom: '7px'}}>
            {tag({title: `Yesterday, ${data.yesterday?.processed || 0} processed`, color: getSemaphoreColor(data.yesterday?.semaphore), size: 12})}
            {tag({title: `Today, ${data.today?.processed || 0} processed`, color: getSemaphoreColor(data.today?.semaphore)})}
            {/* <Tag color={ data.last?.semaphore? semaphoreColors[data.last?.semaphore] : gray}>Last</Tag> */}
        </Flex>
    )) || null;
}
